import * as Yup from 'yup';

export const ageSchema = Yup.lazy((value: string | number) => {
  const isString = Number.isNaN(Number(value));
  if (isString) {
    return Yup.string()
      .required()
      .min(2, 'One character required')
      .label('Age');
  }
  return Yup.number()
    .positive()
    .required()
    .label('Age');
});
